import Keycloak from "keycloak-js";
import { getMockedKeycloakInstance } from "./utils/util";

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_LOGIN_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

let keycloak;

if (window.Cypress) {
  const isAdmin = window.Cypress.env('isAdmin');
  keycloak = getMockedKeycloakInstance(isAdmin);
} else {
  keycloak = new Keycloak(keycloakConfig);
}

export default keycloak;